export enum OptionDispatchTypes {
  OPEN_CART = 'OPEN_CART',
  CLOSE_CART = 'CLOSE_CART',
  OPEN_SEARCH = 'OPEN_SEARCH',
  CLOSE_SEARCH = 'CLOSE_SEARCH',
  OPEN_MENU = 'OPEN_MENU',
  CLOSE__MENU = 'CLOSE_MENU'
}
